import { render } from "./SpecialPacking.vue?vue&type=template&id=12e901af&scoped=true"
import script from "./SpecialPacking.vue?vue&type=script&lang=js"
export * from "./SpecialPacking.vue?vue&type=script&lang=js"

import "./SpecialPacking.vue?vue&type=style&index=0&id=12e901af&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e901af"]])

export default __exports__